export default {
  urls: {
    home: '{siteURL}/{loc}/',
    company: '{siteURL}/{loc}/company.html',
    products: '{siteURL}/{loc}/products.html',
    applications: '{siteURL}/{loc}/applications.html',
    designCenter: '{siteURL}/{loc}/design-center.html',
    education: '{siteURL}/{loc}/education.html',
    support: '{siteURL}/{loc}/support.html',
    sitemap: '{siteURL}/{loc}/sitemap.html',
    legal: '{siteURL}/{loc}/who-we-are/legal-and-risk-oversight.html',
    accessibility: '{siteURL}/{loc}/who-we-are/legal-and-risk-oversight/accessibility-statement.html',
    privacyPolicy: '{siteURL}/{loc}/who-we-are/legal-and-risk-oversight/data-privacy/privacy-policy.html',
    privacySettings: '{siteURL}/{loc}/lp/001/privacy-settings.html',
    cookieSettings: '{siteURL}/{loc}/cookie-notice.html',
  },
};
